import { getCookie } from "../../../../utils/cookie";
import apiRequest from "../../../../utils/apiClient";
import { deleteTranscriptUrl } from "../../../constants";

export const deleteUploadTranscript = async (
  transcriptId: number,
  messageStore: any,
): Promise<boolean> => {
  const body = new FormData();
  body.append("transcript_id", transcriptId.toString());

  try {
    const response = await apiRequest(deleteTranscriptUrl, {
      method: "POST",
      mode: "cors",
      body,
      headers: { "X-CSRFToken": getCookie("csrftoken") },
    });
    if (response.status === 401) {
      messageStore.setMessage("Authentication failed. Please log in again.", "error");
      return false;
    }
    const data = await response.json();
    if (response.ok && data.message === "success") {
      messageStore.setMessage(`Transcript "${data.title}" deleted successfully`, "success");
      return true;
    }
    messageStore.setMessage(`Error deleting transcript: ${data.message || "Unknown error"}`, "error");
    return false;
  } catch (error: any) {
    messageStore.setMessage(`Network error: ${error.message}`, "error");
    return false;
  }
};
